import gql from 'graphql-tag';

import {
  RosterIdentityBaseDetails,
  RosterIdentityLinkedIdentityContactMethodDetails,
  RosterQrCodeExportDetails,
  RosterQrCodeDetails,
} from '../fragments/roster-identity';

export const RosterIdentityHistory = gql`
  query rosterIdentityHistory(
    $roster_identity_ids: [RecordID]!
    $limit: Int = 20
    $offset: Int = 0
  ) {
    me {
      id
      roster_identities(
        slice: { limit: 1 }
        roster_identity_ids: $roster_identity_ids
      ) {
        records {
          id
          ...RosterIdentityBaseDetails
          purchased_custom_prints(slice: { limit: $limit, offset: $offset }) {
            total
            records {
              id
              created_at
              price {
                value
                currency
              }
              roster_identity_linked_identity_address {
                id
                address_line_1
              }
            }
          }
        }
      }
    }
  }
  ${RosterIdentityBaseDetails}
`;

// Requested on demand when the contact info flow opens, so that the
// can_update_contact_methods resolver is not paid for by the member lists.
export const RosterIdentityForContactInfoEdits = gql`
  query rosterIdentityForContactInfoEdits($roster_identity_ids: [RecordID]!) {
    me {
      id
      roster_identities(
        slice: { limit: 1 }
        roster_identity_ids: $roster_identity_ids
      ) {
        records {
          id
          email_addresses {
            total
            records {
              id
              email_address
            }
          }
          linked_identities(slice: { limit: 10 }) {
            total
            records {
              id
              ...RosterIdentityLinkedIdentityContactMethodDetails
            }
          }
        }
      }
    }
  }
  ${RosterIdentityLinkedIdentityContactMethodDetails}
`;

export const RosterQrCodeForOnboarding = gql`
  query rosterQrCodeForOnboarding($roster_qr_code_id: RecordID!) {
    rosterQrCodeForOnboarding(roster_qr_code_id: $roster_qr_code_id) {
      album {
        id
        root_album_folder {
          id
          face_recognition_disabled
        }
      }
      album_folder {
        id
        face_recognition_disabled
      }
      roster_identity {
        id
        first_name
        has_matching_enabled_selfie
      }
      accounts {
        id
        email_addresses
        phone_number
        type
      }
    }
  }
`;

export const RosterIdentityPurchasedCustomPrintPhotos = gql`
  query rosterIdentityPurchasedCustomPrintPhotos(
    $roster_identity_ids: [RecordID]!
  ) {
    me {
      id
      roster_identities(
        slice: { limit: 1 }
        roster_identity_ids: $roster_identity_ids
      ) {
        records {
          id
          photos {
            purchased_custom_print_photos(slice: { limit: 999 }) {
              records {
                id
              }
            }
          }
        }
      }
    }
  }
`;

export const RosterQrCodeExport = gql`
  query rosterQrCodeExport(
    $roster_qr_code_export_id: RecordID!
    $pdf_index: Int!
    $offset: Int = 0
    $limit: Int = 999
  ) {
    rosterQrCodeExport(roster_qr_code_export_id: $roster_qr_code_export_id) {
      ...RosterQrCodeExportDetails
      codes(pdf_index: $pdf_index, slice: { offset: $offset, limit: $limit }) {
        total
        records {
          id
          pdf_index
          roster_qr_code {
            ...RosterQrCodeDetails
          }
        }
      }
    }
  }
  ${RosterQrCodeExportDetails}
  ${RosterQrCodeDetails}
`;
